import * as Dtos from '../../dtos/Tmd.dtos';
import { IFieldState, IRegistrationFormState } from "./index";

export const initialTrialItemCategoryState: Dtos.TrialItemCategory & IRegistrationFormState = {
    categoryId: null,
    category: null,
    trialItems: [],
    trialItemSummaries: [],
    saveAndReturn: null
}

export interface ITrialItemCategoryReduxFormState {
    categoryId: IFieldState<number>,
    category: IFieldState<Dtos.Category>,
    trialItems: IFieldState<Dtos.TrialItem[]>,
    TrialItemSummaries: IFieldState<Dtos.TrialItemSummary[]>
}
